/**
 * Application constants
 * Note: Firebase configs removed - using Django API instead
 */

// API Configuration - uses environment variable or defaults to staging
// CRA only exposes env vars prefixed with REACT_APP_*
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://api-staging.motito.co/v1';
